import { render, staticRenderFns } from "./DeleteEnityWdiget.vue?vue&type=template&id=27c87f7c&"
import script from "./DeleteEnityWdiget.vue?vue&type=script&lang=js&"
export * from "./DeleteEnityWdiget.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEnityWdiget.vue?vue&type=style&index=0&id=27c87f7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports